import { environment } from 'src/environments/environment';

export const connection: any = {
    apiUrl: environment.url,
    apiSfFixedPath: '/services/apexrest',
    apiVersionV1: '1.0.0'
};
